import React, {FC, useEffect, useState} from "react";
import {postLinkedApp} from "../../lib/api";
import {Redirect} from "react-router-dom";

const SketchfabRedirect: FC = () => {
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);

  function getUrlParams(hash: string) {
    let hashes = hash.substr(1).split('&')
    return hashes.reduce((params, keyVal) => {
      let [key, val] = keyVal.split('=')
      return Object.assign(params, {[key]: decodeURIComponent(val)})
    }, {})
  }

  useEffect(() => {
    const urlParams: any = getUrlParams(window.location.search);
    postLinkedApp({
      name: "Sketchfab",
      code: urlParams.code,
      accessToken: null,
      refreshToken: null,
      expires_in: null
    }).then((response) => {
      if (response.ok) {
        setSaved(true);
      } else {
        response.json().then(json => {
          setError(json?.error);
        });
      }
    })
  }, []);

  if (saved) {
    return <Redirect to="/apps"/>
  }

  return (
    <>
      <section className="container main p-4 rounded">
        {error ?
          (
            <div className="row error">
              <div className="col-12">
                {(error as any)?.message}
              </div>
            </div>
          )
          : null
        }
      </section>
    </>
  );
}

export default SketchfabRedirect;
